module.exports = __webpack_public_path__ + "static/media/heart-icon-black.a1717336.png";